import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Cabcompaniesinmumbai() {



  const cardData = {
    keyword: " Cab Companies in Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and comfortable cab services in Mumbai, providing safe, affordable, and 24/7 travel solutions for local rides, airport transfers, corporate travel, and outstation journeys. Whether you are traveling for business, daily commute, family trips, or long-distance travel, our professional drivers and well-maintained vehicles ensure a smooth and stress-free experience. We focus on punctual pickups, transparent pricing, clean cars, and hassle-free booking with no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for every travel need. With easy online booking and quick support, Royal Route Cab is trusted as one of the best cab service options in Mumbai.",

"topPlaces": [
  {
    "title": "Outstation Cab Services",
    "description": "Royal Route Cabs provides reliable outstation cab services from Mumbai to major destinations across Maharashtra and neighboring states. Customers can enjoy comfortable vehicles, professional drivers, and affordable pricing for one-way and round-trip journeys."
  },
  {
    "title": "Airport Transfer Services",
    "description": "Our airport taxi services offer timely pickups and drop-offs to and from Mumbai Airport. With flight tracking, professional chauffeurs, and comfortable vehicles, travelers can enjoy a hassle-free airport transfer experience."
  },
  {
    "title": "Corporate Cab Solutions",
    "description": "Royal Route Cabs offers dedicated corporate transportation services for business meetings, employee travel, and executive transfers. Our well-maintained fleet ensures punctuality, comfort, and professionalism."
  },
  {
    "title": "One Way Taxi Service",
    "description": "Our one-way cab service helps travelers save money by paying only for the distance traveled. This option is ideal for airport transfers, city-to-city travel, and business trips from Mumbai."
  },
  {
    "title": "Round Trip Cab Booking",
    "description": "Royal Route Cabs provides affordable round-trip taxi packages with flexible schedules and waiting options. Customers can enjoy a complete travel solution for family vacations, pilgrimages, and business tours."
  },
  {
    "title": "Luxury Car Rental",
    "description": "We offer luxury car rental services featuring premium vehicles for weddings, VIP travel, corporate events, and special occasions. Our luxury fleet combines comfort, style, and professionalism."
  },
  {
    "title": "Innova Crysta Fleet",
    "description": "The Toyota Innova Crysta is one of our most popular vehicles for family travel and group transportation. It offers spacious seating, superior comfort, and a smooth ride for long-distance journeys."
  },
  {
    "title": "Sedan Cab Services",
    "description": "Our sedan cabs are perfect for individuals, couples, and small families seeking economical and comfortable travel. Clean interiors and experienced drivers ensure a pleasant journey."
  },
  {
    "title": "SUV Taxi Services",
    "description": "Royal Route Cabs provides spacious SUV taxis for larger groups and travelers carrying extra luggage. SUVs offer excellent comfort and safety for long-distance and outstation travel."
  },
  {
    "title": "24/7 Cab Booking Support",
    "description": "Our customer support team is available round the clock to assist with bookings, travel planning, and route information. We ensure a smooth and reliable cab booking experience for every customer."
  }
],






services: [
  {
    name: "Cab Companies in Mumbai",
    description: "Cab companies in Mumbai offer a wide range of transportation services including local travel, airport transfers, and outstation trips. These companies provide well-maintained vehicles and experienced drivers for safe and comfortable journeys. Suitable for individuals, families, and corporate clients. It ensures reliable and convenient travel options across the city."
  },
  {
    name: "Taxi Companies in Mumbai",
    description: "Taxi companies in Mumbai provide easy and accessible transportation solutions for daily commuting and long-distance travel. These companies offer various vehicle options with professional drivers. Flexible booking options and competitive pricing enhance convenience. It ensures smooth and dependable travel."
  },
  {
    name: "Top Cab Providers Mumbai",
    description: "Top cab providers Mumbai offer premium travel services with high-quality vehicles and trained chauffeurs. These providers focus on punctuality, safety, and customer satisfaction. Ideal for local, airport, and outstation travel. It guarantees a reliable and comfortable journey."
  },
  {
    name: "Best Taxi Companies Mumbai",
    description: "Best taxi companies Mumbai deliver top-class transportation services with well-maintained vehicles and professional drivers. These companies ensure high standards of comfort and reliability. Suitable for business and personal travel. It ensures a premium travel experience."
  },
  {
    name: "Car Rental Companies Mumbai",
    description: "Car rental companies Mumbai offer flexible vehicle rental options for personal and corporate use. Customers can choose from a wide range of cars including sedans, SUVs, and luxury vehicles. Suitable for short-term and long-term rentals. It ensures customized travel solutions."
  },
  {
    name: "Cab Service Providers Mumbai",
    description: "Cab service providers Mumbai deliver reliable and convenient transportation services across the city. These providers cater to local travel, airport transfers, and outstation trips. Professional drivers and clean vehicles ensure comfort. It guarantees a hassle-free journey."
  },
  {
    name: "Taxi Operators Mumbai",
    description: "Taxi operators Mumbai manage fleets of vehicles for city and intercity travel. These operators ensure efficient service with experienced drivers and maintained cars. Suitable for daily commuting and business travel. It ensures dependable transportation."
  },
  {
    name: "Local Cab Companies Mumbai",
    description: "Local cab companies Mumbai provide quick and affordable travel within the city. These services are ideal for office commutes, shopping trips, and daily errands. Easy booking and quick availability make it convenient. It ensures smooth city travel."
  },
  {
    name: "Outstation Cab Companies Mumbai",
    description: "Outstation cab companies Mumbai offer comfortable long-distance travel to nearby cities and destinations. These companies provide one way and round trip packages. Vehicles are maintained for highway travel. It ensures a safe and enjoyable journey."
  },
  {
    name: "Airport Taxi Companies Mumbai",
    description: "Airport taxi companies Mumbai provide seamless pickup and drop services to domestic and international terminals. These services ensure timely arrival and departure for flights. Professional drivers and clean vehicles enhance comfort. It guarantees a stress-free airport transfer."
  },
  {
    name: "Trusted Cab Companies Mumbai",
    description: "Trusted cab companies Mumbai are known for reliable and secure travel services. These companies use verified drivers and well-maintained vehicles. Suitable for families and solo travelers. It ensures safe and comfortable journeys."
  },
  {
    name: "Professional Taxi Companies Mumbai",
    description: "Professional taxi companies Mumbai deliver high-standard travel services with trained chauffeurs and quality vehicles. These companies focus on punctuality and customer satisfaction. Ideal for corporate and personal travel. It ensures a smooth experience."
  },
  {
    name: "Affordable Cab Companies Mumbai",
    description: "Affordable cab companies Mumbai provide budget-friendly travel options without compromising on quality. These services are ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures value-driven travel."
  },
  {
    name: "List of Cab Companies Mumbai",
    description: "List of cab companies Mumbai includes various providers offering local, airport, and outstation services. Customers can compare options based on pricing and vehicle types. This helps in selecting the best service provider. It simplifies decision-making."
  },
  {
    name: "Leading Taxi Service Mumbai",
    description: "Leading taxi service Mumbai offers premium transportation solutions with a focus on quality and reliability. These services provide well-maintained vehicles and experienced drivers. Suitable for all types of travel needs. It guarantees a top-class travel experience."
  }
],

tableData: [
  ["Cab Companies in Mumbai", "Taxi Companies in Mumbai"],
  ["Top Cab Providers Mumbai", "Best Taxi Companies Mumbai"],
  ["Car Rental Companies Mumbai", "Cab Service Providers Mumbai"],
  ["Taxi Operators Mumbai", "Local Cab Companies Mumbai"],
  ["Outstation Cab Companies Mumbai", "Airport Taxi Companies Mumbai"],
  ["Trusted Cab Companies Mumbai", "Professional Taxi Companies Mumbai"],
  ["Affordable Cab Companies Mumbai", "List of Cab Companies Mumbai"],
  ["Leading Taxi Service Mumbai", "Cab Companies in Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Top Cab Companies in Mumbai",
    WhyChoosedescription: "Royal Route Cabs stands among the best cab companies in Mumbai, offering reliable local and outstation travel services."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained, verified, and experienced in handling city and long-distance routes across Mumbai."
  },
  {
    WhyChooseheading: "Wide Range of Cab Services",
    WhyChoosedescription: "We provide local rides, airport transfers, corporate travel, outstation cabs, and customized tour packages."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs ensures clear pricing with no hidden costs, giving customers complete fare transparency."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our cab services in Mumbai are available 24/7 for daily travel, emergencies, and late-night rides."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are regularly serviced, sanitized, and maintained to provide a comfortable travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for all travel needs."
  },
  {
    WhyChooseheading: "Trusted Cab Service Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers as one of the leading cab companies in Mumbai for punctual and reliable service."
  }
]

};

const faqData = [
  { question: "Which are the best cab companies in Mumbai?", answer: "Royal Route Cabs is one of the best cab service providers in Mumbai offering reliable local and outstation travel." },
  { question: "Do you provide cab services across Mumbai?", answer: "Yes, we provide cab services across all areas including South Mumbai, Andheri, Borivali, Navi Mumbai, and Thane." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai cab service operates 24/7." },
  { question: "Do you provide airport cab service?", answer: "Yes, we offer airport pickup and drop services from Mumbai Airport (T1 & T2)." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide outstation cab services?", answer: "Yes, we provide outstation cab services from Mumbai to various destinations." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Can I book a cab online?", answer: "Yes, you can easily book cabs online or via phone booking." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Joshi",
    feedback: "Among several cab companies in Mumbai, Royal Route Cabs delivered a truly reliable experience. The booking was easy and the service quality was consistently professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback: "Service quality from Royal Route Cabs in Mumbai felt very dependable and well-organized. The ride experience was smooth, punctual, and comfortable from start to finish.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Companies in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/cab-companies-in-mumbai.jpg", // replace if needed
  "description": "Royal Route Cabs is one of the trusted cab companies in Mumbai offering reliable taxi services for local, airport, and outstation travel. Safe, affordable, and 24x7 cab booking with professional drivers and multiple vehicle options.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // starting local cab price (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/cab-companies-in-mumbai"
  }
};








  return (
    <div>

<Helmet>
  <title>Cab Companies in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Royal Route Cabs is among the best cab companies in Mumbai offering local, airport, and outstation taxi services. Safe, reliable, and affordable 24x7 cab booking available."
  />

  <meta
    name="keywords"
    content="cab companies in mumbai, taxi companies in mumbai, top cab providers mumbai, best taxi companies mumbai, car rental companies mumbai, cab service providers mumbai, taxi operators mumbai, local cab companies mumbai, outstation cab companies mumbai, airport taxi companies mumbai, trusted cab companies mumbai, professional taxi companies mumbai, affordable cab companies mumbai, list of cab companies mumbai, leading taxi service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/32.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabcompaniesinmumbai;